import {
    TextField,
    Button,
    Select as PolarisSelect,
    Modal,
    DropZone,
    Toast,
    Popover,
    ActionList,
    ChoiceList,
    Link,
    Thumbnail,
    Checkbox,
    Banner,
    Tooltip,
    BlockStack,
    Text,
    RadioButton,
    InlineStack,
    Divider,
    Tag,
    Tabs,
    Listbox,
    Combobox,
    Icon,
    Spinner,
} from '@shopify/polaris';
import { FixedSizeList as List } from 'react-window';
import { NoteMinor, MobileVerticalDotsMajor, ImportMinor, AlertMinor, SearchMinor, SearchMajor } from '@shopify/polaris-icons';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Modal as ModalAnt } from 'antd';
import { DIProps } from '../../../../Core';
import { environment } from '../../../../environments/environment';
import Select from 'react-select';
import Adminactions from './Adminactions';
import Noimage from '../../../../../public/files/noImage.png';
import SearchFeildUsingComboBox from './SearchFeildUsingComboBox';
import { useTour } from '../../../Other/tour';
import { GridApis } from '../Utilities/Apis';
import {
    Activity,
    Type,
    barcodeExist,
    optionForVendor,
    optionsSKUSelect,
    filterKeySelect,
    status,
    fulfillmentTypeOptions,
    filterKeySelectTemplate,
} from '../Utilities/Constants';
import CustomFilter from '../../../../Libs/CustomFilters/CustomFilter';
import { useTranslation } from 'react-i18next';
import { t } from 'i18next';
import { isAdminLoggedIn } from '../../Panel/index';
import { useDebounce } from '../../useDebounce';

const betaSeller = ['66f5087bd4d2d4b667094a17'];

interface Props extends DIProps {
    setallFiltersNew: (data: any) => void;
    allFiltersNew: any;
    amazonLookupBulk: () => void;
    amazonSync: () => void;
    AmazonLokupLoading: boolean;
    setappliedFilters: (data: any) => void
    Rows: any;
    FilterQuery: () => any;
    SyncLoading: boolean;
    queryValue: string;
    setqueryValue: (data: string) => void;
    selectedFlag: Array<string>;
    selectedFlagChild: Array<string>;
    activityRefreshAction: () => void;
    disableActions: boolean;
    filterapplied: () => string;
    setSelectOpt: (data: any) => any;
    isBulkEdit?: boolean;
    selectedRows?: any;
    manageColumns?: (payload: any) => void;
    handleClearAllFilters: () => void
    appliedFilters: any;
    columns?: any[];
    gridLoading: boolean;
}

function GridActions(Props: Props) {
    const { t } = useTranslation();
    const { setTourLoading, isOpen } = useTour();
    const [filter, setfilter] = useState([]);
    const [width, setWidth] = useState(window.innerWidth);
    const [inputValue, setInputValue] = useState('');
    const [exportModal, setexportModal] = useState(false);
    const [importModal, setimportModal] = useState(false);
    const [allAPIOptions, setallAPIOptions] = useState<any>({});
    const [templateOption, settemplateOption] = useState<any>([]);
    const [Data, setData] = useState<any>({
        title: '',
        description: '',
        actionName: '',
    });
    const [actionType, setActionType] = useState<string>("");
    const [active, setActive] = useState<boolean>(false);
    const [options, setOptions] = useState<any>([]);
    const [loading, setloading] = useState<boolean>(false);
    const [Fileame, setFileame] = useState('');
    const [fileExists, setfileExists] = useState(false);

    //destructuring all props from product componet
    const {
        disableActions,
        activityRefreshAction,
        setappliedFilters,
        handleClearAllFilters,
        selectedFlagChild,
        filterapplied,
        allFiltersNew,
        Rows,
        queryValue,
        selectedFlag,
        setqueryValue,
        setallFiltersNew,
        AmazonLokupLoading,
        appliedFilters,
        SyncLoading,
        amazonLookupBulk,
        amazonSync,
        setSelectOpt,
    } = Props;

    const handleInputSesrchFilter = useCallback(
        (newValue: string) => setInputValue(newValue),
        []
    );

    const [popoverActive, setPopoverActive] = useState(false);

    const togglePopoverActiveUpdate = useCallback(
        () => setPopoverActive((popoverActive) => !popoverActive),
        []
    );

    const activator = (
        <Button
            size='large'
            onClick={togglePopoverActiveUpdate}
            icon={MobileVerticalDotsMajor}
        />
    );

    const fetchFilterAttributes = useCallback(
        async (overrides: { limit?: number; filters?: any } = {}) => {
            const basePayload = {
                source: {
                    shopId: Props.redux.current.source._id,
                    marketplace: Props.redux.current.source.marketplace,
                },
                target: {
                    shopId: Props.redux.current.target._id,
                    marketplace: Props.redux.current.target.marketplace,
                },
                use_atlas: true,
                limit: 100,
            };

            // merge in any overrides (e.g. new limit or filter attributes)
            const payload = { ...basePayload, ...overrides };
            try {
                const resp = await Props.di.POST(GridApis.getFilterAttributes, payload);
                if (!resp.success) throw new Error(resp.message);

                const opts = { ...appliedFilters };
                resp.data.forEach((item: any) => {
                    switch (item.code) {
                        case 'variant_attributes':
                            opts.variantAttributesOption = item.options;
                            break;
                        case 'brand':
                            opts.venderAttributeOption = item.options;
                            break;
                        case 'amazonProductType':
                            opts['product-type'] = item.options;
                            break;
                        case 'label':
                            opts.label = item.options;
                            break;
                    }
                });
                setallAPIOptions(opts);
            } catch (err) {
                console.error('getFilterAttributes failed', err);
            }
        },
        [Props, appliedFilters]
    );

    // 1) on mount, just fetch the defaults:
    useEffect(() => {
        fetchFilterAttributes();
    }, []);

    // 2) whenever your filter state changes, re‑fetch with those filters:
    useEffect(() => {
        // assume allFiltersNew is an object of { code: { selectValue, textValue, change } }
        const activeFilters = Object.entries(allFiltersNew)
            .filter(([, cfg]: any) => cfg.change)
            .reduce((acc: any, [code, cfg]: any) => {
                acc[code] = {
                    selectValue: cfg.selectValue,
                    textValue: cfg.textValue,
                };
                return acc;
            }, {} as Record<string, any>);

        if (Object.keys(activeFilters).length > 0) {
            fetchFilterAttributes({ filters: activeFilters });
        }
    }, [allFiltersNew]);

    useEffect(() => {
        Props.di
            .GET(
                `${GridApis.getProfileData}?all_profile_name=true&sort_order=desc`
            )
            .then((response) => {
                if (response.success) {
                    let tempData: any = [];
                    let tempData2: any = [];
                    let temp2: any = [];
                    let obj: any = {};
                    response?.projectData?.forEach((profile: any) => {
                        tempData.push({
                            label: profile?.['name'],
                            value: profile?.['_id']?.['$oid'],
                        });

                        if (profile?.type === 'manual') {
                            let profName = profile?.['_id']?.['$oid'];
                            obj = {
                                [profName]: profile?.manual_product_ids,
                            };
                            temp2.push(obj);
                            tempData2.push({
                                label: profile?.['name'],
                                value: profile?.['_id']?.['$oid'],
                            });
                        }
                    });
                    setSelectOpt({
                        options: tempData2,
                        manualIds: temp2,
                    });
                    settemplateOption(tempData);
                } else {
                    console.error(response.message);
                }
            });
    }, []);

    useEffect(() => {
        Props.di.GET(GridApis.exportedFileName).then((response: any) => {
            if (response.success) {
                setFileame(response?.data?.value);
                setfileExists(true);
            }
        });
    }, []);

    useEffect(() => {
        let temp: any = { ...appliedFilters };
        let allFiltersNewTems = JSON.parse(Props.di.globalState.get(`${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`, true) || "{}") || allFiltersNew
        Object.keys(allFiltersNewTems).forEach((key) => {
            if (allFiltersNewTems[key].change) {
                if (key == 'Inventory') {
                    temp[key] = {
                        key: key,
                        label: `${t(key)} ${filterKeySelect(t).filter((val) => {
                            return (
                                val?.value ==
                                allFiltersNewTems?.[key]?.selectValue
                            );
                        })?.[0]?.['label']
                            } ${t(allFiltersNewTems[key]['textValue'])}`,
                        // onRemove: handleQueryValueRemove,
                    };
                } else if (key === 'Activity') {
                    temp[key] = {
                        key: key,
                        label: `${t(key)} ${filterKeySelect(t).filter((val) => {
                            return (
                                val.value ==
                                allFiltersNewTems?.[key]?.selectValue
                            );
                        })?.[0]?.['label']
                            } ${t(Activity(t).filter(
                                (value) =>
                                    value.value ==
                                    allFiltersNewTems[key]['textValue']
                            )?.[0]?.['label']
                            )}`,
                        // onRemove: handleQueryValueRemove,
                    };
                } else if (key === 'Container_id') {
                    temp[key] = {
                        key: key,
                        label: `${allFiltersNewTems[key]?.type} ${t("Contains")} ${allFiltersNewTems?.[key]?.['searchvalue']}`,
                        // onRemove: handleQueryValueRemove,
                    };
                } else if (key === 'Template name') {
                    temp[key] = {
                        key: key,
                        label: `${t(key)} ${filterKeySelect(t).filter((val) => {
                            return (
                                val?.value ==
                                allFiltersNewTems?.[key]?.selectValue
                            );
                        })?.[0]?.['label']
                            } ${t(allFiltersNewTems?.[key]?.['label'])}`,
                        // onRemove: handleQueryValueRemove,
                    };
                }
                else if (key === 'Template name multi') {
                    temp[key] = {
                        key: key,
                        label: `${t('Template name')} ${filterKeySelectTemplate(t).filter((val) => {
                            return (
                                val?.value ==
                                allFiltersNewTems?.[key]?.selectValue
                            );
                        })?.[0]?.['label']
                            } ${t(allFiltersNewTems?.[key]?.['label'])}`,
                        // onRemove: handleQueryValueRemove,
                    };
                }
                else if (key === 'Vendor multi') {
                    console.log(filterKeySelect(t), allFiltersNewTems?.[key]?.selectValue, "xdcfgvbhnjsxdcfvgbhnjmk")
                    temp[key] = {
                        key: key,
                        label: `${t('Vendor ')} ${filterKeySelect(t).filter((val) => {
                            return (
                                val?.value ==
                                allFiltersNewTems?.[key]?.selectValue
                            );
                        })?.[0]?.['label'] ?? "Equals"
                            } ${t(allFiltersNewTems?.[key]?.['label'])}`,
                        // onRemove: handleQueryValueRemove,
                    };
                }
                else if (key === 'label') {
                    temp[key] = {
                        key: key,
                        label: `${t('Label ')} ${filterKeySelectTemplate(t).filter((val) => {
                            return (
                                val?.value ==
                                allFiltersNewTems?.[key]?.selectValue
                            );
                        })?.[0]?.['label']
                            } ${t(allFiltersNewTems?.[key]?.['label'])}`,
                        // onRemove: handleQueryValueRemove,
                    };
                }
                else if (key === 'Error') {
                    temp[key] = {
                        key: key,
                        label: `${t(key)} ${filterKeySelect(t).filter((val) => {
                            return (
                                val?.value ==
                                allFiltersNewTems?.[key]?.selectValue
                            );
                        })?.[0]?.['label']
                            } ${t(allFiltersNewTems?.[key]?.['errorName'])}`,
                        // onRemove: handleQueryValueRemove,
                    };
                } else if (key === 'Barcode Exists') {
                    temp[key] = {
                        key: key,
                        label: `${t("Barcode Exists")} ${allFiltersNewTems?.[key]?.['textValue'] == '1'
                            ? t('True')
                            : t('False')
                            }`,
                        // onRemove: handleQueryValueRemove,
                    };
                } else {
                    temp[key] = {
                        key: key,
                        label: `${t(key)}
                        ${optionsSKUSelect(t).filter((val) => {
                            return (
                                val?.value ==
                                allFiltersNewTems?.[key]?.selectValue
                            );
                        })?.[0]?.['label']
                            }
                            ${t(allFiltersNewTems?.[key]?.['textValue'])}`,
                        // onRemove: handleQueryValueRemove,
                    };
                }
            } else delete temp[key];
        });
        setappliedFilters(temp);
    }, [Props.di.globalState.get(`${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`, true)]);

    useEffect(() => {
        let filter: any = [];
        let tempData: any = { ...allFiltersNew };
        Object.keys(tempData).forEach((key) => {
            if (key == 'title') {
                setqueryValue(tempData[key].textValue);
            }
            switch (key) {
                case 'Inventory':
                    filter[0] = {
                        key: 'Inventory',
                        label: t('Inventory'),
                        filter: (
                            <BlockStack gap="200">
                                <PolarisSelect
                                    label=""
                                    placeholder=""
                                    options={filterKeySelect(t)}
                                    value={tempData[key]?.selectValue}
                                    onChange={(value) => {
                                        tempData[key]['selectValue'] = value;
                                        if (tempData[key]['textValue'] !== '')
                                            Props.di.globalState.removeLocalStorage(
                                                'pagination'
                                            );
                                        Props.di.globalState.removeLocalStorage(
                                            'inputpage'
                                        );
                                        Props.di.globalState.set(
                                            `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                                            JSON.stringify(tempData),
                                            true
                                        );
                                        setallFiltersNew({ ...tempData });
                                    }}
                                />
                                <TextField
                                    min="0"
                                    placeholder={t("enter value")}
                                    type="number"
                                    labelHidden
                                    autoComplete="off"
                                    label={undefined}
                                    value={allFiltersNew[key]?.textValue}
                                    onChange={(value) => {
                                        tempData[key]['textValue'] =
                                            value.trim() != ''
                                                ? parseInt(value).toFixed()
                                                : 0;
                                        tempData[key]['change'] =
                                            value.trim() != '' ? true : false;
                                        Props.di.globalState.removeLocalStorage(
                                            'pagination'
                                        );
                                        Props.di.globalState.removeLocalStorage(
                                            'inputpage'
                                        );
                                        Props.di.globalState.set(
                                            `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                                            JSON.stringify(tempData),
                                            true
                                        );
                                        setallFiltersNew({ ...tempData });
                                    }}
                                />
                            </BlockStack>
                        ),
                    };
                    break;
                case 'title':
                    filter[1] = {
                        key: 'title',
                        label: t('Title'),
                        filter: (
                            <BlockStack gap="200">
                                <PolarisSelect
                                    label=""
                                    placeholder=""
                                    options={optionsSKUSelect(t)}
                                    value={t(tempData[key]['selectValue'])}
                                    onChange={(value) => {

                                        tempData[key]['selectValue'] = value;
                                        if (tempData[key]['textValue'] !== '')
                                            Props.di.globalState.removeLocalStorage(
                                                'pagination'
                                            );
                                        Props.di.globalState.removeLocalStorage(
                                            'inputpage'
                                        );
                                        Props.di.globalState.set(
                                            `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                                            JSON.stringify(tempData),
                                            true
                                        );
                                        setallFiltersNew({ ...tempData });
                                    }}
                                />
                                <TextField
                                    labelHidden
                                    autoComplete="off"
                                    label={undefined}
                                    placeholder={t("enter value")}
                                    value={tempData[key]['textValue']}
                                    onChange={(value) => {
                                        if (tempData?.['Container_id']?.change && (tempData['Container_id']['type'] == 'shipify SKU' || tempData['Container_id']['type'] == 'SKU')) {
                                            tempData['Container_id']['change'] = false
                                            tempData['Container_id']['searchvalue'] = ''
                                            tempData['Container_id']['type'] = ''
                                            setInputValue("")
                                        }
                                        tempData[key]['textValue'] =
                                            value.trim() != '' ? value : '';
                                        tempData[key]['change'] =
                                            value.trim() != '' ? true : false;
                                        Props.di.globalState.removeLocalStorage(
                                            'pagination'
                                        );
                                        Props.di.globalState.removeLocalStorage(
                                            'inputpage'
                                        );
                                        Props.di.globalState.set(
                                            `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                                            JSON.stringify(tempData),
                                            true
                                        );
                                        setallFiltersNew({ ...tempData });
                                    }}
                                />
                            </BlockStack>
                        ),
                    };
                    break;
                case 'SKU':
                    filter[2] = {
                        key: 'SKU',
                        label: t('SKU'),
                        filter: (
                            <BlockStack gap="200">
                                <PolarisSelect
                                    label=""
                                    placeholder=""
                                    options={optionsSKUSelect(t)}
                                    value={t(tempData[key]['selectValue'])}
                                    onChange={(value) => {
                                        tempData[key]['selectValue'] = value;
                                        if (tempData[key]['textValue'] !== '')
                                            Props.di.globalState.removeLocalStorage(
                                                'pagination'
                                            );
                                        Props.di.globalState.removeLocalStorage(
                                            'inputpage'
                                        );
                                        Props.di.globalState.set(
                                            `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                                            JSON.stringify(tempData),
                                            true
                                        );
                                        setallFiltersNew({ ...tempData });
                                    }}
                                />
                                <TextField
                                    labelHidden
                                    autoComplete="off"
                                    label={undefined}
                                    placeholder={t("enter value")}
                                    value={tempData[key]['textValue']}
                                    onChange={(value) => {
                                        if (tempData?.['Container_id']?.change && (tempData['Container_id']['type'] == 'shipify SKU' || tempData['Container_id']['type'] == 'SKU')) {
                                            tempData['Container_id']['change'] = false
                                            tempData['Container_id']['searchvalue'] = ''
                                            tempData['Container_id']['type'] = ''
                                            setInputValue("")
                                        }
                                        tempData[key]['textValue'] =
                                            value.trim() != '' ? value : '';
                                        tempData[key]['change'] =
                                            value.trim() != '' ? true : false;
                                        Props.di.globalState.removeLocalStorage(
                                            'pagination'
                                        );
                                        Props.di.globalState.removeLocalStorage(
                                            'inputpage'
                                        );
                                        Props.di.globalState.set(
                                            `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                                            JSON.stringify(tempData),
                                            true
                                        );
                                        setallFiltersNew({ ...tempData });
                                    }}
                                />
                            </BlockStack>
                        ),
                    };
                    break;
                case 'Tags':
                    filter[3] = {
                        key: 'Tags',
                        label: t('Tags'),
                        filter: (
                            <TextField
                                labelHidden
                                autoComplete="off"
                                label={undefined}
                                placeholder={t("enter value")}
                                value={tempData[key]['textValue']}
                                onChange={(value) => {
                                    tempData[key]['textValue'] =
                                        value.trim() != '' ? value : '';
                                    tempData[key]['change'] =
                                        value.trim() != '' ? true : false;
                                    Props.di.globalState.removeLocalStorage(
                                        'pagination'
                                    );
                                    Props.di.globalState.removeLocalStorage(
                                        'inputpage'
                                    );
                                    Props.di.globalState.set(
                                        `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                                        JSON.stringify(tempData),
                                        true
                                    );
                                    setallFiltersNew({ ...tempData });
                                }}
                            />
                        ),
                    };
                    break;
                case 'Product type':
                    filter[4] = {
                        key: 'Product type',
                        label: t('Product type'),
                        filter: (
                            <TextField
                                labelHidden
                                autoComplete="off"
                                placeholder={t("enter value")}
                                label={undefined}
                                value={tempData[key]['textValue']}
                                onChange={(value) => {
                                    tempData[key]['textValue'] =
                                        value.trim() != '' ? value : '';
                                    tempData[key]['change'] =
                                        value.trim() != '' ? true : false;
                                    Props.di.globalState.removeLocalStorage(
                                        'pagination'
                                    );
                                    Props.di.globalState.removeLocalStorage(
                                        'inputpage'
                                    );
                                    Props.di.globalState.set(
                                        `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                                        JSON.stringify(tempData),
                                        true
                                    );
                                    setallFiltersNew({ ...tempData });
                                }}
                            />
                        ),
                    };
                    break;
                case 'Vendor':
                    filter[5] = {
                        key: 'Vendor',
                        label: t('Vendor'),
                        filter: (
                            <BlockStack gap="200">
                                <PolarisSelect
                                    label=""
                                    placeholder=""
                                    options={optionForVendor(t)}
                                    value={tempData[key]['selectValue']}
                                    onChange={(value) => {
                                        tempData[key]['selectValue'] = value;
                                        if (tempData[key]['textValue'] !== '')
                                            Props.di.globalState.removeLocalStorage(
                                                'pagination'
                                            );
                                        Props.di.globalState.removeLocalStorage(
                                            'inputpage'
                                        );
                                        Props.di.globalState.set(
                                            `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                                            JSON.stringify(tempData),
                                            true
                                        );
                                        setallFiltersNew({ ...tempData });
                                    }}
                                />
                                <Select
                                    menuPortalTarget={document.getElementById('root')}
                                    menuPlacement='auto'
                                    classNamePrefix="Custom__Select"
                                    placeholder={t("Choose...")}
                                    options={
                                        allAPIOptions.venderAttributeOption
                                    }
                                    value={
                                        tempData[key]['textValue'] !== ''
                                            ? {
                                                label: tempData[key][
                                                    'textValue'
                                                ],
                                                value: tempData[key][
                                                    'textValue'
                                                ],
                                            }
                                            : { label: t('Choose...'), value: '' }
                                    }
                                    onChange={(value: any) => {
                                        tempData[key]['textValue'] =
                                            value.label;
                                        tempData[key]['change'] = true;
                                        Props.di.globalState.removeLocalStorage(
                                            'pagination'
                                        );
                                        Props.di.globalState.removeLocalStorage(
                                            'inputpage'
                                        );
                                        Props.di.globalState.set(
                                            `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                                            JSON.stringify(tempData),
                                            true
                                        );
                                        setallFiltersNew({ ...tempData });
                                    }}
                                />
                            </BlockStack>
                        ),
                    };
                    break;
                case 'Vendor multi':
                    filter[5] = {
                        key: 'Vendor multi',
                        label: t('Vendor'),
                        filter: (
                            <BlockStack gap="200">
                                <TemplateCombobox
                                    setInputValue={setInputValue}
                                    inputValue={inputValue}
                                    templateOption={allAPIOptions.venderAttributeOption}
                                    selectedTemplates={tempData[key].textValue || []}
                                    filter={"Vender"}
                                    onSelect={(value: any) => {
                                        handleselectChange(value, key, allAPIOptions.venderAttributeOption);
                                        if (isOpen && Props.di.globalState.get('start_tour') === 'bulk_tour_2' && value !== "") {
                                            setTourLoading(true);
                                        }
                                    }}
                                    fetchOptions={async (query: any) => {
                                        // If user types something not in the 10 initial items,
                                        // call the same endpoint but pass "filters" that include this query:
                                        if (query.length > 0) {
                                            await fetchFilterAttributes({
                                                filters: {
                                                    brand: { textValue: query, selectValue: '', change: true },
                                                },
                                            });
                                        } else {
                                            await fetchFilterAttributes();

                                        }

                                        // after that state update, your allAPIOptions.venderAttributeOption
                                        // will include the new items from the server:
                                        console.log(allAPIOptions, "evefvevevverver")
                                        return allAPIOptions.venedrAttributeOption?.map((opt: any) => ({
                                            label: opt.label,
                                            value: opt.value,
                                        }));
                                    }}
                                />
                            </BlockStack>
                        ),
                    };
                    break;
                case 'Template name multi':
                    filter[6] = {
                        key: 'Template name multi',
                        label: t('Template Name'),
                        filter: (
                            <TemplateCombobox2
                                templateOption={templateOption}
                                selectedTemplates={tempData[key].textValue}
                                filter={"Template"}
                                onSelect={(value: any) => {
                                    handleselectChange(value, key, templateOption);
                                    if (isOpen && Props.di.globalState.get('start_tour') === 'bulk_tour_2' && value !== "") {
                                        setTourLoading(true);
                                    }
                                    // // Update the selected value in tempData
                                    // tempData[key].textValue = [...value];
                                    // Props.di.globalState.set(
                                    //     `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                                    //     JSON.stringify(tempData),
                                    //     true
                                    // );
                                    // setallFiltersNew({ ...tempData });
                                }}
                            />
                        ),
                    };
                    break;
                case 'Product Status':
                    filter[7] = {
                        key: 'Product Status',
                        label: t('Product status'),
                        filter: (
                            <PolarisSelect
                                disabled={false}
                                label=""
                                placeholder={t("Choose...")}
                                value={
                                    status(t).filter((value) => {
                                        return (
                                            value.code ==
                                            allFiltersNew[key].textValue
                                        );
                                    })[0]?.['value']
                                }
                                options={status(t)}
                                onChange={(value) =>
                                    handleselectChange(value, key, status(t))
                                }
                            />
                        ),
                    };
                    break;
                case 'Variant attributes':
                    filter[8] = {
                        key: 'Variant attributes',
                        label: t('Variant Attributes'),
                        filter: (
                            <PolarisSelect
                                disabled={false}
                                label=""
                                placeholder={t("Choose...")}
                                value={
                                    allAPIOptions?.variantAttributesOption?.filter(
                                        (value: any) => {
                                            return (
                                                value.label ==
                                                allFiltersNew[key].textValue
                                            );
                                        }
                                    )[0]?.['value']
                                }
                                options={allAPIOptions.variantAttributesOption}
                                onChange={(value) =>
                                    handleselectChange(
                                        value,
                                        key,
                                        allAPIOptions.variantAttributesOption
                                    )
                                }
                            />
                        ),
                    };
                    break;
                case 'Activity':
                    filter[9] = {
                        key: 'Activity',
                        label: t('Activity'),
                        filter: (
                            <PolarisSelect
                                disabled={false}
                                label=""
                                placeholder={t("Choose...")}
                                value={
                                    Activity(t).filter((value) => {
                                        return (
                                            value.value ==
                                            allFiltersNew[key].textValue
                                        );
                                    })[0]?.['value']
                                }
                                options={Activity(t)}
                                onChange={(value) =>
                                    handleselectChange(value, key, Activity(t))
                                }
                            />
                        ),
                    };
                    break;
                case 'Type':
                    filter[10] = {
                        key: 'Type',
                        label: t('Type'),
                        filter: (
                            <PolarisSelect
                                disabled={false}
                                label=""
                                placeholder={t("Choose...")}
                                value={
                                    Type(t).filter((value) => {
                                        return (
                                            value.code ==
                                            allFiltersNew[key].textValue
                                        );
                                    })[0]?.['value']
                                }
                                options={Type(t)}
                                onChange={(value) =>
                                    handleselectChange(value, key, Type(t))
                                }
                            />
                        ),
                    };
                    break;
                case 'Barcode Exists':
                    filter[11] = {
                        key: 'Barcode Exists',
                        label: t('Barcode Exists'),
                        filter: (
                            <PolarisSelect
                                label=""
                                placeholder={t("Choose...")}
                                value={
                                    barcodeExist.filter((value) => {
                                        return (
                                            value.value ==
                                            allFiltersNew[key].textValue
                                        );
                                    })?.[0]?.['value']
                                }
                                options={barcodeExist}
                                onChange={(value) =>
                                    handleselectChange(
                                        value,
                                        'Barcode Exists',
                                        barcodeExist
                                    )
                                }
                            />
                        ),
                    };
                    break;
                case 'Fulfilment Type':
                    filter[12] = {
                        key: 'Fulfilment Type',
                        label: t('Fulfilment Type'),
                        filter: (
                            <PolarisSelect
                                label=""
                                placeholder={t("Choose...")}
                                value={
                                    fulfillmentTypeOptions(t).filter((value) => {
                                        return (
                                            value.value ==
                                            allFiltersNew[key].textValue
                                        );
                                    })?.[0]?.['value']
                                }
                                options={fulfillmentTypeOptions(t)}
                                onChange={(value) =>
                                    handleselectChange(
                                        value,
                                        key,
                                        fulfillmentTypeOptions(t)
                                    )
                                }
                            />
                        ),
                    };
                    break;
                case 'Amazon Recommended Product Type':
                    filter[13] = {
                        key: 'Amazon Recommended Product Type',
                        label: t('Amazon Recommended Product Type'),
                        filter: (
                            <BlockStack gap="200">

                                <Select
                                    menuPortalTarget={document.getElementById('root')}
                                    menuPlacement='auto'
                                    classNamePrefix="Custom__Select"
                                    placeholder={t("Choose...")}
                                    options={
                                        allAPIOptions?.['product-type']
                                    }
                                    value={
                                        tempData[key]['textValue'] !== ''
                                            ? {
                                                label: tempData[key][
                                                    'textValue'
                                                ],
                                                value: tempData[key][
                                                    'textValue'
                                                ],
                                            }
                                            : { label: t('Choose...'), value: '' }
                                    }
                                    onChange={(value: any) => {
                                        tempData[key]['textValue'] =
                                            value.label;
                                        tempData[key]['change'] = true;
                                        Props.di.globalState.removeLocalStorage(
                                            'pagination'
                                        );
                                        Props.di.globalState.removeLocalStorage(
                                            'inputpage'
                                        );
                                        Props.di.globalState.set(
                                            `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                                            JSON.stringify(tempData),
                                            true
                                        );
                                        setallFiltersNew({ ...tempData });
                                    }}
                                />
                            </BlockStack>
                        ),
                    };
                    break;

                case 'label':
                    isAdminLoggedIn() ? filter[14] = {
                        key: 'lable',
                        label: t('Label'),
                        filter: (
                            <TemplateCombobox
                                templateOption={allAPIOptions.label}
                                selectedTemplates={tempData[key].textValue}
                                filter={"Template"}
                                onSelect={(value: any) => {
                                    handleselectChange(value, key, allAPIOptions?.label);
                                    if (isOpen && Props.di.globalState.get('start_tour') === 'bulk_tour_2' && value !== "") {
                                        setTourLoading(true);
                                    }
                                    // // Update the selected value in tempData
                                    // tempData[key].textValue = [...value];
                                    // Props.di.globalState.set(
                                    //     `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                                    //     JSON.stringify(tempData),
                                    //     true
                                    // );
                                    // setallFiltersNew({ ...tempData });
                                }}
                            />
                        ),
                    } : null
                    break;
            }
        });
        setfilter(filter);
    }, [allFiltersNew, allAPIOptions, templateOption]);
    const handleRemoveFilter = useCallback(
        (flag: any) => {
            Object.keys(allFiltersNew).forEach((key) => {
                let temp = { ...allFiltersNew };
                if (key?.toLowerCase() == flag?.toLowerCase()) {
                    temp[key]['textValue'] = '';
                    temp[key]['change'] = false;
                    Props.di.globalState.removeLocalStorage('pagination');
                    Props.di.globalState.removeLocalStorage('inputpage');
                    setappliedFilters([]);
                    setallFiltersNew({ ...temp });
                    Props.di.globalState.set(
                        `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                        JSON.stringify(temp),
                        true
                    );
                    setqueryValue('');
                }
            });
        },
        [allFiltersNew]
    );

    const handleFiltersQueryChange = useCallback(
        (value: any) => {
            Props.di.globalState.removeLocalStorage('inputpage');
            Object.keys(allFiltersNew).forEach((key) => {
                let temp = { ...allFiltersNew };
                if (value == 'Container_id') setInputValue('');
                if (value == key) {
                    temp[key]['textValue'] = '';
                    temp[key]['change'] = false;
                    setallFiltersNew(temp);
                    Props.di.globalState.set(
                        `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                        JSON.stringify(temp),
                        true
                    );
                }
            });
        },
        [allFiltersNew]
    );






    const handleselectChange = useCallback(
        (value: any, keyFilter: string, type: any) => {
            Props.di.globalState.removeLocalStorage('pagination');
            Props.di.globalState.removeLocalStorage('inputpage');
            let tempData = { ...allFiltersNew };
            Object.keys(tempData).forEach((key) => {
                if (key == keyFilter && keyFilter == 'Activity') {
                    tempData[key]['textValue'] = value;
                    tempData[key]['change'] = true;
                    Props.di.globalState.set(
                        `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                        JSON.stringify(tempData),
                        true
                    );
                    setallFiltersNew({ ...tempData });
                } else if (key == keyFilter && keyFilter == 'Product Status') {
                    tempData[key]['textValue'] = value;
                    tempData[key]['value'] =
                        value == 'Not Listed'
                            ? 'cif_amazon_multi_inactive' : value == 'Uploaded' ? 'cif_amazon_multi_uploaded'
                                : 'items.status';
                    tempData[key]['change'] = true;
                    Props.di.globalState.set(
                        `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                        JSON.stringify(tempData),
                        true
                    );
                    setallFiltersNew({ ...tempData });
                } else if (key == keyFilter && keyFilter == 'Fulfilment Type') {
                    tempData[key]['textValue'] = value;
                    tempData[key]['value'] =
                        value == 'FBM'
                            ? 'cif_amazon_multi_fulfillment_type'
                            : 'items.fulfillment_type';
                    tempData[key]['change'] = true;
                    Props.di.globalState.set(
                        `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                        JSON.stringify(tempData),
                        true
                    );
                    setallFiltersNew({ ...tempData });
                } else if (key == keyFilter && keyFilter == 'Template name') {
                    tempData[key]['textValue'] = type.filter(
                        (valueFilter: any) => {
                            return valueFilter.value == value;
                        }
                    )[0]['value'];
                    tempData[key]['label'] = type.filter((valueFilter: any) => {
                        return valueFilter.value == value;
                    })[0]['label'];
                    tempData[key]['change'] = true;
                    Props.di.globalState.set(
                        `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                        JSON.stringify(tempData),
                        true
                    );
                    setallFiltersNew({ ...tempData });
                }
                else if (key == keyFilter && keyFilter == 'Template name multi') {
                    if (value.length > 0) {
                        tempData[key]['textValue'] = value
                        tempData[key]['label'] = type?.filter((option: any) => value.includes(option.value))
                            .map((option: any) => option.label)
                            .join(', ');
                        tempData[key]['change'] = true;
                    } else {
                        tempData[key]['textValue'] = []
                        tempData[key]['label'] = "";
                        tempData[key]['change'] = false;


                    }

                    Props.di.globalState.set(
                        `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                        JSON.stringify(tempData),
                        true
                    );
                    setallFiltersNew({ ...tempData });
                }
                else if (key == keyFilter && keyFilter == 'Vendor multi') {
                    if (value.length > 0) {
                        tempData[key]['textValue'] = value
                        tempData[key]['label'] = type?.filter((option: any) => value.includes(option.value))
                            .map((option: any) => option.label)
                            .join(', ');
                        tempData[key]['change'] = true;
                    } else {
                        tempData[key]['textValue'] = []
                        tempData[key]['label'] = "";
                        tempData[key]['change'] = false;
                    }
                    Props.di.globalState.set(
                        `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                        JSON.stringify(tempData),
                        true
                    );
                    setallFiltersNew({ ...tempData });
                }
                else if (key == keyFilter && keyFilter == 'label') {
                    if (value.length > 0) {
                        tempData[key]['textValue'] = value
                        tempData[key]['label'] = type?.filter((option: any) => value.includes(option.value))
                            .map((option: any) => option.label)
                            .join(', ');
                        tempData[key]['change'] = true;
                    } else {
                        tempData[key]['textValue'] = []
                        tempData[key]['label'] = "";
                        tempData[key]['change'] = false;
                    }
                    Props.di.globalState.set(
                        `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                        JSON.stringify(tempData),
                        true
                    );
                    setallFiltersNew({ ...tempData });
                }



                else if (key == keyFilter && keyFilter == 'Barcode Exists') {
                    tempData[key]['textValue'] = type.filter(
                        (valueFilter: any) => {
                            return valueFilter.value == value;
                        }
                    )[0]['value'];
                    tempData[key]['label'] = type.filter((valueFilter: any) => {
                        return valueFilter.value == value;
                    })[0]['label'];
                    (tempData[key]['change'] = true),
                        Props.di.globalState.set(
                            `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                            JSON.stringify(tempData),
                            true
                        );
                    setallFiltersNew({ ...tempData });
                } else if (key == keyFilter && keyFilter == 'Type') {

                    tempData[key]['textValue'] = type.filter(
                        (valueFilter: any) => {
                            return valueFilter.value == value;
                        }
                    )[0]['code'];
                    tempData[key]['change'] = true;
                    Props.di.globalState.set(
                        `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                        JSON.stringify(tempData),
                        true
                    );
                    setallFiltersNew({ ...tempData });
                } else if (key == keyFilter) {
                    tempData[key]['textValue'] = type.filter(
                        (valueFilter: any) => {
                            return valueFilter.value == value;
                        }
                    )[0]['label'];
                    tempData[key]['change'] = true;
                    Props.di.globalState.set(
                        `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                        JSON.stringify(tempData),
                        true
                    );
                    setallFiltersNew({ ...tempData });
                }
            });
        },
        []
    );



    // For Changing Button Position on mobile view
    useEffect(() => {
        function handleResize() {
            setWidth(window.innerWidth);
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [width]);

    const getHitTitle: any = (valueResult: any, val: any) => {
        let newtext: any;
        valueResult = valueResult?.replace(/(<strong >|<\/strong>)/gim, '');
        try {
            let regex = new RegExp(val, 'gi');
            newtext = valueResult?.replace(regex, '<strong >$&</strong>');
        } catch (err) {
            console.error(err);
            newtext = val;
        }
        return newtext;
    };

    const getHitBrand: any = (valueResult: any, val: any) => {
        let newtext: any;
        valueResult = valueResult?.replace(/(<strong >|<\/strong>)/gim, '');
        try {
            let regex = new RegExp(val, 'gi');
            newtext = valueResult?.replace(regex, '<strong >$&</strong>');
        } catch (err) {
            console.error(err);
            newtext = valueResult;
        }
        return newtext;
    };

    const getHitProductType: any = (valueResult: any, val: any) => {
        let newtext: any;
        try {
            let regex = new RegExp(val, 'gi');
            newtext = valueResult?.replace(regex, '<strong >$&</strong>');
        } catch (err) {
            console.error(err);
            newtext = val;
        }
        return newtext;
    };

    const fetchSearchData: any = async (
        value: string,
        selectedOptForSearch: any
    ) => {
        let tempData: any = [];
        value = value.trim();
        if (value.length !== 0) {
            const response = await Props.di.POST(
                GridApis.getSearchSuggestions,
                {
                    query: value,
                    searchOpt: selectedOptForSearch,
                }
            );
            if (response.success) {
                setloading(false)

                response?.data?.forEach((searchResult: any, index: number) => {
                    const highestSearchResult =
                        searchResult?.highlights.length > 0 &&
                        searchResult?.highlights?.reduce(
                            (prev: any, current: any) => {
                                return prev.score > current.score
                                    ? prev
                                    : current;
                            }
                        );

                    searchResult?.items?.forEach((item: any) => {
                        if (highestSearchResult?.path == 'items.title') {
                            tempData.push({
                                label: (

                                    <div style={{ cursor: 'pointer' }}>
                                        <InlineStack gap="300">
                                            <Thumbnail source={item['main_image'] || Noimage} size="small" alt="Black choker necklace" />
                                            <BlockStack gap="100">
                                                <Text as="p" fontWeight="regular">
                                                    <span dangerouslySetInnerHTML={{ __html: getHitTitle(searchResult?.title, value) }} />
                                                </Text>
                                                <Text variant="bodySm" as="p">
                                                    {item?.sku || 'N/A'}-
                                                    {item.barcode || 'N/A'}
                                                </Text>
                                            </BlockStack>
                                        </InlineStack>
                                    </div>
                                ),
                                value: item?.source_product_id,
                                container_id: searchResult?.container_id,
                                id: `gid://shopify/CustomerSegment/${item?.source_product_id}`,
                                type: t('title'),
                                inputValue: inputValue,
                                data: searchResult?.title,
                            });
                        } else if (highestSearchResult?.path == 'brand') {
                            tempData.push({
                                label: (

                                    <div style={{ cursor: 'pointer' }}>
                                        <InlineStack gap="300">
                                            <Thumbnail source={item['main_image'] || Noimage} size="small" alt="Black choker necklace" />
                                            <BlockStack gap="100">
                                                <Text as="p" fontWeight="regular">
                                                    {typeof searchResult?.title != 'object' ? searchResult?.title : 'N/A'}
                                                </Text>
                                                <Text variant="bodySm" as="p">
                                                    <span dangerouslySetInnerHTML={{ __html: 'Brand: ' + getHitBrand(searchResult?.brand, value) || 'N/A' }} />
                                                </Text>
                                            </BlockStack>
                                        </InlineStack>
                                    </div>
                                ),
                                value: item?.source_product_id,
                                container_id: searchResult?.container_id,
                                id: `gid://shopify/CustomerSegment/${item?.source_product_id}`,
                                data: searchResult?.brand,
                                type: 'Vendor',
                                inputValue: inputValue,
                            });
                        } else if (
                            highestSearchResult?.path == 'product_type'
                        ) {
                            tempData.push({
                                label: (

                                    <div style={{ cursor: 'pointer' }}>
                                        <InlineStack gap="300">
                                            <Thumbnail source={item['main_image'] || Noimage} size="small" alt="Black choker necklace" />
                                            <BlockStack gap="100">
                                                <Text as="p" fontWeight="regular">
                                                    {typeof searchResult?.title != 'object' ? searchResult?.title : 'N/A'}
                                                </Text>
                                                <Text variant="bodySm" as="p">
                                                    <span dangerouslySetInnerHTML={{ __html: 'Product Type: ' + getHitProductType(searchResult?.product_type, value) || 'N/A' }} />
                                                </Text>
                                            </BlockStack>
                                        </InlineStack>
                                    </div>
                                ),
                                value: item?.source_product_id,
                                container_id: searchResult?.container_id,
                                id: `gid://shopify/CustomerSegment/${item?.source_product_id}`,
                                type: 'Product_type',
                                data: searchResult?.product_type,
                                inputValue: inputValue,
                            });
                        } else if (
                            highestSearchResult?.path == 'items.barcode'
                        ) {
                            tempData.push({
                                label: (
                                    <div style={{ cursor: 'pointer' }}>
                                        <InlineStack gap="300">
                                            <Thumbnail source={item['main_image'] || Noimage} size="small" alt="Black choker necklace" />
                                            <BlockStack gap="100">
                                                <Text as="p" fontWeight="regular">
                                                    {typeof searchResult?.title != 'object' ? searchResult?.title : 'N/A'}
                                                </Text>
                                                <Text variant="bodySm" as="p">
                                                    <span dangerouslySetInnerHTML={{ __html: 'Barcode: ' + getHitProductType(highestSearchResult?.texts?.[0]?.value, value) }}></span>
                                                </Text>
                                            </BlockStack>
                                        </InlineStack>
                                    </div>
                                ),
                                value: item?.source_product_id,
                                container_id: searchResult?.container_id,
                                id: `gid://shopify/CustomerSegment/${item?.source_product_id}`,
                                type: t('Barcode'),
                                data: highestSearchResult?.texts?.[0]?.value,
                                inputValue: inputValue,
                            });
                        } else if (
                            highestSearchResult?.path == 'items.sku' &&
                            item?.sku?.includes(
                                highestSearchResult?.texts?.[0]?.value
                            )
                        ) {
                            tempData.push({
                                label: (
                                    <div style={{ cursor: 'pointer' }}>
                                        <InlineStack gap="300">
                                            <Thumbnail source={item['main_image'] || Noimage} size="small" alt="Black choker necklace" />
                                            <BlockStack gap="100">
                                                <Text as="p" fontWeight="regular">
                                                    {typeof searchResult?.title != 'object' ? searchResult?.title : 'N/A'}
                                                </Text>
                                                <Text variant="bodySm" as="p">
                                                    <span dangerouslySetInnerHTML={{ __html: 'SKU: ' + getHitProductType(highestSearchResult?.texts?.filter((value: any) => value.type == 'hit')?.[0]?.value, value) || 'N/A' }} />
                                                </Text>
                                            </BlockStack>
                                        </InlineStack>
                                    </div>
                                ),
                                value: item?.source_product_id,
                                container_id: searchResult?.container_id,
                                id: `gid://shopify/CustomerSegment/${item?.source_product_id}`,
                                type: t('SKU'),
                                data: highestSearchResult?.texts?.filter(
                                    (value: any) => value.type == 'hit'
                                )?.[0]?.value,
                                inputValue: inputValue,
                            });
                        }
                        else if (
                            highestSearchResult?.path == 'items.shopify_sku' &&
                            item?.shopify_sku?.includes(
                                highestSearchResult?.texts?.[0]?.value
                            )
                        ) {
                            tempData.push({
                                label: (
                                    <div style={{ cursor: 'pointer' }}>
                                        <InlineStack gap="300">
                                            <Thumbnail source={item['main_image'] || Noimage} size="small" alt="Black choker necklace" />
                                            <BlockStack gap="100">
                                                <Text as="p" fontWeight="regular">
                                                    {typeof searchResult?.title != 'object' ? searchResult?.title : 'N/A'}
                                                </Text>
                                                <Text variant="bodySm" as="p">
                                                    <span dangerouslySetInnerHTML={{ __html: 'shopify SKU: ' + getHitProductType(highestSearchResult?.texts?.filter((value: any) => value.type == 'hit')?.[0]?.value, value) || 'N/A' }} />
                                                </Text>
                                            </BlockStack>
                                        </InlineStack>
                                    </div>
                                ),
                                value: item?.source_product_id,
                                container_id: searchResult?.container_id,
                                id: `gid://shopify/CustomerSegment/${item?.source_product_id}`,
                                type: t('shipify SKU'),
                                data: highestSearchResult?.texts?.filter(
                                    (value: any) => value.type == 'hit'
                                )?.[0]?.value,
                                inputValue: inputValue,
                            });
                        }
                    });
                });

                setOptions(tempData);
            } else {
            }
        } else {
            setOptions([]);
        }
    };



    const openModalbulkAction = useCallback((x: any) => {
        if (x === 'import') {
            setimportModal(true);
        } else if (x === 'export') {
            setexportModal(true);
        }
    }, []);
    const setTitleFilter = (
        data: any
    ) => {


        let tempFilter = { ...allFiltersNew };
        let selectedOption = options.filter(
            (option: any) => option['container_id'] === data[0]
        )[0];




        Props.di.globalState.removeLocalStorage('pagination');
        Props.di.globalState.removeLocalStorage('inputpage');
        Object.keys(tempFilter).forEach((key) => {

            if (selectedOption.type == 'Title') {
                if (key == 'title') {
                    // if (selectedOption?.type == 'shipify SKU' || selectedOption?.type == 'SKU') {
                    //     if (tempFilter['SKU']['change']) {
                    //         tempFilter['SKU']['change'] = false;
                    //         tempFilter['SKU']['textValue'] = '';
                    //     }
                    // }
                    tempFilter[key]['textValue'] = selectedOption?.data;
                    tempFilter[key]['type'] = selectedOption?.type;
                    tempFilter[key]['selectValue'] = 1;
                    tempFilter[key]['searchvalue'] = selectedOption?.data;
                    tempFilter[key]['change'] = true;
                    Props.di.globalState.set(
                        `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                        JSON.stringify(tempFilter),
                        true
                    );
                    setallFiltersNew({ ...tempFilter });
                }
            } else {
                if (key == 'Container_id') {
                    if (selectedOption?.type == 'shipify SKU' || selectedOption?.type == 'SKU') {
                        if (tempFilter['SKU']['change']) {
                            tempFilter['SKU']['change'] = false;
                            tempFilter['SKU']['textValue'] = '';
                        }
                    }
                    tempFilter[key]['textValue'] = selectedOption?.container_id;
                    tempFilter[key]['type'] = selectedOption?.type;
                    tempFilter[key]['selectValue'] = 1;
                    tempFilter[key]['searchvalue'] = selectedOption?.data;
                    tempFilter[key]['change'] = true;
                    Props.di.globalState.set(
                        `${Props.redux?.user_id}_${Props.redux?.current?.target?._id}_filters`,
                        JSON.stringify(tempFilter),
                        true
                    );
                    setallFiltersNew({ ...tempFilter });
                }
            }

        });
    };


    return (
        <React.Fragment>
            <BlockStack gap="200">
                <InlineStack gap="200" align='space-between'>
                    {width <= 767 && (
                        <div >
                            <InlineStack gap="100" wrap={false}>
                                <InlineStack gap="200">
                                    <div style={{ flex: '1 1 auto' }}>
                                        <Tooltip
                                            zIndexOverride={9999}
                                            preferredPosition="above"
                                            content={
                                                <BlockStack
                                                    gap="100"
                                                    align="space-between">
                                                    <Text as="p">
                                                        The <Text as='p' fontWeight='bold'>Sync Status</Text> action connects Amazon listings with imported Shopify products using SKU and barcode. It ensures real-time status updates, handles bulk changes, flags errors, and keeps your listings on Amazon accurate and up to date.
                                                    </Text>
                                                </BlockStack>
                                            }
                                            dismissOnMouseOut>
                                            <Button
                                                disabled={disableActions}
                                                loading={SyncLoading}
                                                onClick={() => {
                                                    // setData({
                                                    //     title: 'Sync Status',
                                                    //     description:
                                                    //         ' It will search sku(s) in your Amazon’s seller panel. For all the products with matching sku(s), status of main products will shown under Amazon Status and variant’s status will reflect on Edit Product page.<br><br>Do you want to proceed with matching all the product(s) from Amazon to that on app ?',
                                                    //     actionName: 'Proceed',
                                                    // });
                                                    setActionType('Sync Status')
                                                    setActive(true);
                                                }}>
                                                {t("Sync Status")}
                                            </Button>
                                        </Tooltip>
                                    </div>
                                    <Popover
                                        active={popoverActive}
                                        activator={activator}
                                        autofocusTarget="first-node"
                                        onClose={togglePopoverActiveUpdate}>
                                        <ActionList
                                            actionRole="menuitem"
                                            items={[
                                                {
                                                    content: t('Amazon Lookup'),
                                                    helpText:
                                                        t('It checks if your products’ barcodes are unique or if they are already available on amazon.'),
                                                    onAction: () => {
                                                        setActionType('Amazon Lookup')
                                                        setActive(true);
                                                    },
                                                },
                                                {
                                                    content: t('Bulk Updates'),
                                                    helpText:
                                                        t('Link your existing Amazon listings with Shopify Products imported in the app.'),
                                                    onAction: () =>
                                                        openModalbulkAction(
                                                            'export'
                                                        ),
                                                },
                                            ]}
                                        />
                                    </Popover>
                                </InlineStack>
                            </InlineStack>
                        </div>
                    )}
                    {filter.length > 0 ?
                        <div
                            className="custom-filter filter-active">
                            <InlineStack gap="400">
                                <div
                                    className="custom-filter filter-active">
                                    <InlineStack gap="200" blockAlign="center">
                                        <div
                                            className="Custom-Polaris--Connected">
                                            <SearchFeildUsingComboBox
                                                {...Props}
                                                setloading={setloading}
                                                fetchSearchData={
                                                    fetchSearchData
                                                }
                                                loading={loading}
                                                options={options}
                                                setOptions={setOptions}
                                                setInputValue={
                                                    handleInputSesrchFilter
                                                }
                                                inputValue={inputValue}
                                                setTitleFilter={setTitleFilter}
                                            // manageColumns={
                                            //     Props?.manageColumns
                                            // }
                                            />
                                        </div>
                                        {filter?.length > 0 && (
                                            <CustomFilter
                                                btnText={t("More filters")}
                                                filters={filter}
                                                onClearAll={handleClearAllFilters}
                                                appliedFilters={Object.values(
                                                    appliedFilters
                                                )}
                                                handleRemoveFilter={
                                                    handleRemoveFilter
                                                }
                                                hideSearchbar
                                                rowsLength={Rows.length}
                                            />
                                        )}

                                        {(Props.di.globalState.get(
                                            'admin_login',
                                            true
                                        ) || process.env.REACT_APP_PROD === "0") && (

                                                <div >
                                                    <InlineStack gap="100">
                                                        <Adminactions
                                                            {...Props}
                                                            selectedRowKeys={
                                                                selectedFlag
                                                            }
                                                            selectedFlagChild={
                                                                selectedFlagChild
                                                            }
                                                            activityRefreshAction={
                                                                activityRefreshAction
                                                            }
                                                        />
                                                    </InlineStack>
                                                </div>
                                            )}
                                    </InlineStack>
                                </div>
                            </InlineStack>
                        </div>
                        : <div className='min-h-32'></div>}
                    {width >= 768 && (
                        <div>
                            {!Props?.isBulkEdit && (
                                <InlineStack gap="200" align="end">
                                    <InlineStack gap="200">
                                        <Tooltip
                                            zIndexOverride={999}
                                            preferredPosition="above"
                                            content={
                                                <InlineStack gap={'025'}>
                                                    <Text as='p' fontWeight='bold' >'Sync Status'</Text>
                                                    <Text as="p">
                                                        action connects Amazon listings with imported Shopify products using SKU and barcode. It ensures real-time status updates, handles bulk changes, flags errors, and keeps your listings on Amazon accurate and up to date.
                                                    </Text>
                                                </InlineStack>


                                            }
                                            dismissOnMouseOut>
                                            <Button
                                                size='large'
                                                disabled={disableActions}
                                                loading={SyncLoading}
                                                onClick={() => {
                                                    setActionType('Sync Status')
                                                    setActive(true);
                                                }}>
                                                {t("Sync Status")}
                                            </Button>
                                        </Tooltip>
                                        <Popover
                                            active={popoverActive}
                                            activator={activator}
                                            autofocusTarget="first-node"
                                            onClose={togglePopoverActiveUpdate}>
                                            <ActionList
                                                actionRole="menuitem"
                                                items={[
                                                    {
                                                        content:
                                                            t('Amazon Lookup'),
                                                        helpText:
                                                            t('It checks if your products’ barcodes are unique or if they are already available on amazon.'),
                                                        onAction: () => {
                                                            setActionType('Amazon Lookup')
                                                            setActive(true);
                                                        },
                                                    },
                                                    {
                                                        content: t('Bulk Updates'),
                                                        helpText:
                                                            t('Link your existing Amazon listings with Shopify Products imported in the app.'),
                                                        onAction: () =>
                                                            openModalbulkAction(
                                                                'export'
                                                            ),
                                                    },
                                                ]}
                                            />
                                        </Popover>
                                    </InlineStack>
                                </InlineStack>
                            )}
                        </div>
                    )}
                </InlineStack>
                <InlineStack gap="200">
                    {Object.keys(appliedFilters).length > 0 &&
                        Object.keys(appliedFilters).map((filter) => {
                            if (filter == 'Error') {
                                return (
                                    <Tooltip
                                        content={
                                            appliedFilters?.[filter]?.['label']
                                        }
                                        dismissOnMouseOut
                                        key={filter}>
                                        <Tag
                                            onRemove={() =>
                                                handleFiltersQueryChange(filter)
                                            }
                                            key={filter}>
                                            <span>
                                                {appliedFilters?.[filter]?.label
                                                    ?.length > 50
                                                    ? appliedFilters?.[
                                                        filter
                                                    ]?.label?.substr(0, 50) +
                                                    '...'
                                                    : appliedFilters?.[filter]
                                                        ?.label}
                                            </span>
                                        </Tag>
                                    </Tooltip>
                                );
                            }

                            else {
                                return (
                                    appliedFilters?.[filter]?.label.length > 150 ?
                                        <Tooltip dismissOnMouseOut content={appliedFilters?.[filter]?.label}>
                                            <Tag
                                                onRemove={() =>
                                                    handleFiltersQueryChange(filter)
                                                }
                                                key={filter}>

                                                {t(appliedFilters?.[filter]?.label?.slice(0, 40))}...

                                            </Tag>
                                        </Tooltip> :
                                        <Tag
                                            onRemove={() =>
                                                handleFiltersQueryChange(filter)
                                            }
                                            key={filter}>
                                            {appliedFilters?.[filter]?.label}

                                        </Tag>
                                )

                            }
                        })}
                </InlineStack>
            </BlockStack>
            <RenderModalForExport {...Props} t={t} exportModal={exportModal} Rows={Rows}
                filterapplied={filterapplied} allFiltersNew={allFiltersNew} Fileame={Fileame} setFileame={setFileame} fileExists={fileExists}
                setexportModal={setexportModal}
                setimportModal={setimportModal} importModal={importModal} />

            <RenderBulkModal active={active} {...Props} t={t} setActive={setActive} amazonSync={amazonSync} amazonLookupBulk={amazonLookupBulk} Data={Data} actionType={actionType}></RenderBulkModal>

            {/* <RenderBulkModal amazonLookupBulk={amazonLookupBulk} amazonSync={amazonSync} active={active} actionType={actionType} setActive={setActive}  ></RenderBulkModal> */}
        </React.Fragment>
    );
}

function AddToast(props: any) {
    const { duration, message, error } = props;
    const [ToastActive, setToastActive] = useState(true);
    const toggleActive = useCallback(
        () => setToastActive((ToastActive) => !ToastActive),
        []
    );
    const toastMarkup = ToastActive ? (
        <Toast
            duration={duration}
            content={message && message}
            onDismiss={toggleActive}
            error={error ?? false}
        />
    ) : null;
    return <React.Fragment>{message && toastMarkup}</React.Fragment>;
}



export default GridActions;


interface Option {
    label: string;
    value: string;
}
const TemplateCombobox: any = ({
    templateOption,
    selectedTemplates,
    onSelect,
    filter,
    fetchOptions,
}: any) => {
    const [inputValue, setInputValue] = useState<string>('');
    const [selectedOptions, setSelectedOptions] = useState<string[]>(selectedTemplates || []);
    const [options, setOptions] = useState<Option[]>(templateOption);
    const [loading, setLoading] = useState<boolean>(false);

    // Keep local state in sync with props
    useEffect(() => {
        setSelectedOptions(selectedTemplates || []);
    }, [selectedTemplates]);

    useEffect(() => {
        setOptions(templateOption);
    }, [templateOption]);

    // Add or remove a tag
    const updateSelection = useCallback(
        (value: string) => {
            const newSelected = selectedOptions.includes(value)
                ? selectedOptions.filter((v) => v !== value)
                : [...selectedOptions, value];
            setSelectedOptions(newSelected);
            onSelect(newSelected);
            setInputValue('');
        },
        [selectedOptions, onSelect],
    );

    // Remove a tag from the list
    const removeTag = useCallback(
        (value: string) => () => {
            const newSelected = selectedOptions.filter((v) => v !== value);
            setSelectedOptions(newSelected);
            onSelect(newSelected);
        },
        [selectedOptions, onSelect],
    );

    // Render the selected tags
    const tagsMarkup = useMemo(() => {
        if (selectedOptions?.length === 0) return null;
        return selectedOptions.map((value) => {
            const label = options?.find((o) => o.value === value)?.label || value;
            return (
                <Tag key={value} onRemove={removeTag(value)}>
                    {label}
                </Tag>
            );
        });
    }, [selectedOptions, options, removeTag]);

    // Escape regex special chars
    const escapeSpecialRegExCharacters = useCallback(
        (v: string) => v.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'),
        [],
    );


    // Handle input change: local filter or fallback fetch
    const updateText = useCallback((value: string) => {
        setInputValue(value);
    }, []);

    const debouncedValue = useDebounce(inputValue, 500);
    const lastFetchedQueryRef = useRef<string | null>(null);
    useEffect(() => {
        const runFetch = async () => {
            if (!debouncedValue) {
                setOptions(templateOption); // Reset to initial options if input cleared
                lastFetchedQueryRef.current = '';
                return;
            }

            if (
                typeof fetchOptions === 'function' &&
                debouncedValue !== lastFetchedQueryRef.current
            ) {
                lastFetchedQueryRef.current = debouncedValue;
                setLoading(true);
                try {
                    const fetched = await fetchOptions(debouncedValue);
                    setOptions(Array.isArray(fetched) ? fetched : []);
                } catch (err) {
                    console.error('TemplateCombobox.fetchOptions error', err);
                    setOptions([]);
                } finally {
                    setLoading(false);
                }
            }
        };

        runFetch();
    }, [debouncedValue, fetchOptions, templateOption]);

    // Row renderer for react-window
    const Row = useCallback(
        ({ index, style }: { index: number; style: React.CSSProperties }) => {
            const opt = options[index];
            if (!opt) return null;
            return (
                <div style={style}>
                    <Listbox.Option
                        key={opt.value}
                        value={opt.value}
                        selected={selectedOptions.includes(opt.value)}
                        accessibilityLabel={opt.label}
                    >
                        {opt.label}
                    </Listbox.Option>
                </div>
            );
        },
        [options, selectedOptions],
    );

    return (
        <div style={{ height: 'auto' }}>
            <BlockStack gap="100">
                <Combobox
                    allowMultiple
                    activator={
                        <Combobox.TextField
                            prefix={
                                loading ? <Spinner size="small" /> : <Icon source={SearchMajor} />
                            }
                            label={t('Search templates')}
                            labelHidden
                            onChange={updateText}
                            value={inputValue}
                            placeholder={
                                options?.length > 0
                                    ? t('Search templates...')
                                    : t('No templates available')
                            }
                            autoComplete="off"
                        />
                    }
                >
                    <div className="custom-combobox__options">
                        {options?.length > 0 ? (
                            <Listbox onSelect={updateSelection}>
                                <List
                                    height={180}
                                    itemCount={options?.length}
                                    itemSize={35}
                                    width="100%"
                                >
                                    {Row}
                                </List>
                            </Listbox>
                        ) : (
                            <InlineStack
                                blockAlign="center"
                                align="start"
                                gap="100"
                            >
                                <Icon source={SearchMinor} />
                                <span>{t(`No ${filter} found.`)}</span>
                            </InlineStack>
                        )}
                    </div>
                </Combobox>
                <InlineStack gap="050">{tagsMarkup}</InlineStack>
            </BlockStack>
        </div>
    );
};

const TemplateCombobox2: any = ({
    templateOption,
    selectedTemplates,
    onSelect,
    filter,
    fetchOptions,
}: any) => {
    const [inputValue, setInputValue] = useState<string>('');
    const [selectedOptions, setSelectedOptions] = useState<string[]>(selectedTemplates || []);
    const [options, setOptions] = useState<Option[]>(templateOption);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        setSelectedOptions(selectedTemplates || []);
    }, [selectedTemplates]);

    useEffect(() => {
        setOptions(templateOption);
    }, [templateOption]);

    const updateSelection = useCallback(
        (value: string) => {
            const newSelected = selectedOptions.includes(value)
                ? selectedOptions.filter((v) => v !== value)
                : [...selectedOptions, value];
            setSelectedOptions(newSelected);
            onSelect(newSelected);
            setInputValue('');
        },
        [selectedOptions, onSelect],
    );

    const removeTag = useCallback(
        (value: string) => () => {
            const newSelected = selectedOptions.filter((v) => v !== value);
            setSelectedOptions(newSelected);
            onSelect(newSelected);
        },
        [selectedOptions, onSelect],
    );

    const tagsMarkup = useMemo(() => {
        if (selectedOptions?.length === 0) return null;
        return selectedOptions.map((value) => {
            const label = options?.find((o) => o.value === value)?.label || value;
            return (
                <Tag key={value} onRemove={removeTag(value)}>
                    {label}
                </Tag>
            );
        });
    }, [selectedOptions, options, removeTag]);

    const escapeSpecialRegExCharacters = useCallback(
        (v: string) => v.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'),
        [],
    );

    const updateText = useCallback((value: string) => {
        setInputValue(value);
    }, []);

    const debouncedValue = useDebounce(inputValue, 500);
    const lastFetchedQueryRef = useRef<string | null>(null);

    useEffect(() => {
        const runFetch = async () => {
            if (!debouncedValue) {
                setOptions(templateOption); // Reset to initial options if input cleared
                lastFetchedQueryRef.current = '';
                return;
            }

            // Case-insensitive local filtering when no fetchOptions
            if (typeof fetchOptions !== 'function') {
                const lower = debouncedValue.toLowerCase();
                const filtered = templateOption.filter((opt: Option) =>
                    opt.label.toLowerCase().includes(lower)
                );
                setOptions(filtered);
                return;
            }

            // Server-side fetch
            if (debouncedValue !== lastFetchedQueryRef.current) {
                lastFetchedQueryRef.current = debouncedValue;
                setLoading(true);
                try {
                    const fetched = await fetchOptions(debouncedValue);
                    setOptions(Array.isArray(fetched) ? fetched : []);
                } catch (err) {
                    console.error('TemplateCombobox.fetchOptions error', err);
                    setOptions([]);
                } finally {
                    setLoading(false);
                }
            }
        };

        runFetch();
    }, [debouncedValue, fetchOptions, templateOption]);

    const Row = useCallback(
        ({ index, style }: { index: number; style: React.CSSProperties }) => {
            const opt = options[index];
            if (!opt) return null;
            return (
                <div style={style}>
                    <Listbox.Option
                        key={opt.value}
                        value={opt.value}
                        selected={selectedOptions.includes(opt.value)}
                        accessibilityLabel={opt.label}
                    >
                        {opt.label}
                    </Listbox.Option>
                </div>
            );
        },
        [options, selectedOptions],
    );

    return (
        <div style={{ height: 'auto' }}>
            <BlockStack gap="100">
                <Combobox
                    allowMultiple
                    activator={
                        <Combobox.TextField
                            prefix={
                                loading ? <Spinner size="small" /> : <Icon source={SearchMajor} />
                            }
                            label={t('Search templates')}
                            labelHidden
                            onChange={updateText}
                            value={inputValue}
                            placeholder={
                                options?.length > 0
                                    ? t('Search templates...')
                                    : t('No templates available')
                            }
                            autoComplete="off"
                        />
                    }
                >
                    <div className="custom-combobox__options">
                        {options?.length > 0 ? (
                            <Listbox onSelect={updateSelection}>
                                <List
                                    height={180}
                                    itemCount={options?.length}
                                    itemSize={35}
                                    width="100%"
                                >
                                    {Row}
                                </List>
                            </Listbox>
                        ) : (
                            <div style={{ marginLeft: "100px" }}>
                                <span>{t(`No ${filter} found.`)}</span>
                            </div>
                        )}
                    </div>
                </Combobox>
                <InlineStack gap="050">{tagsMarkup}</InlineStack>
            </BlockStack>
        </div>
    );
};



//render bulk update modal
const RenderModalForExport = (props: any) => {
    const { exportModal, t, setexportModal, filterapplied, selectedFlag, allFiltersNew, setFileame, Rows, Fileame, fileExists, setimportModal, importModal } = props;
    const [selected, setSelected] = useState<any>([]);
    const [disable, setDisable] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(false);
    const [checkedTitle, setCheckedTitle] = useState<boolean>(false);
    const [allChecked, setAllChecked] = useState<boolean>(false);
    const [checkedInventory, setCheckedInventory] =
        useState<boolean>(false);
    const [checkedPrice, setCheckedPrice] = useState<boolean>(false);
    const [checkedBarcode, setCheckedBarcode] = useState<boolean>(false);
    const [checkedSku, setCheckedSku] = useState<boolean>(false);
    const handleChange = useCallback(
        (value: any) => setSelected(value),
        []
    );
    const handleChangeExport = useCallback(() => {
        setexportModal(!exportModal);
    }, [exportModal]);
    const handlecheckTitle = (value: boolean) => setCheckedTitle(value);
    const handlecheckAll = (value: boolean) => {
        setAllChecked(value);
        setCheckedPrice(value);
        setCheckedTitle(value);
        setCheckedInventory(value);
        setCheckedBarcode(value);
        setCheckedSku(value);
    };
    const handlecheckPrice = (value: boolean) => setCheckedPrice(value);
    const handlecheckInventory = (value: boolean) =>
        setCheckedInventory(value);
    const handlecheckBarcode = (value: boolean) => setCheckedBarcode(value);
    const handlecheckSku = (value: boolean) => setCheckedSku(value);
    const [indeterminate, setIndeterminate] = useState(false);

    const options = [
        { label: t('Current Page'), value: '2', disabled: Rows?.length <= 0 },
        { label: t('All Product'), value: '3' },
        {
            label: `${t("Selected Products: ")}${selectedFlag?.length} ${t("Product")}`,
            value: '1',
            disabled: selectedFlag?.length <= 0,
        },
        {
            label: t('Found 50+ matching products corresponding to your search'),
            value: '4',
            disabled: (Object.keys(filterapplied())?.length <= 0 || Rows?.length <= 0)
        },
    ];
    useEffect(() => {
        if (selected?.length > 0 && (allChecked || indeterminate)) {
            setDisable(false);
        } else {
            setDisable(true);
        }
    }, [selected, allChecked, indeterminate]);

    useEffect(() => {
        if (
            checkedBarcode &&
            checkedSku &&
            checkedPrice &&
            checkedInventory &&
            checkedTitle
        ) {
            setAllChecked(true);
            setIndeterminate(false);
        } else if (
            checkedBarcode ||
            checkedSku ||
            checkedPrice ||
            checkedInventory ||
            checkedTitle
        ) {
            setIndeterminate(true);
            setAllChecked(false);
        } else if (
            !checkedBarcode &&
            !checkedSku &&
            !checkedPrice &&
            !checkedInventory &&
            !checkedTitle
        ) {
            setIndeterminate(false);
            setAllChecked(false);
        }
    }, [
        checkedSku,
        checkedTitle,
        checkedBarcode,
        checkedPrice,
        checkedInventory,
    ]);

    const exportProductRequest = (param: string) => {
        let postData: any = {};
        postData['useRefinProduct'] = true;
        setLoading(true);
        let data: any = [];
        checkedTitle ? data.push('title') : null;
        checkedInventory ? data.push('quantity') : null;
        checkedPrice ? data.push('price') : null;
        checkedBarcode ? data.push('barcode') : null;
        checkedSku ? data.push('sku') : null;
        postData['dataToExport'] = data;
        param === 'new'
            ? (postData['new_process'] = true)
            : (postData['remove_last'] = true);
        if (selected == '3') {
            postData['type'] = 'all';
        } else if (selected == '1') {
            postData['type'] = 'selected';
            postData['source_product_id'] = selectedFlag;
        } else if (selected == '2') {
            postData['type'] = 'current';
            let tempData: any = [];
            Rows.forEach((row: any) => {
                tempData.push(row?.source_product_id);
            });
            postData['source_product_id'] = tempData;
        } else if (selected == '4') {
            postData['type'] = 'filter';
            let data: any = {};
            Object.keys(allFiltersNew).map((key: any) => {
                if (allFiltersNew[key].change) {
                    data[allFiltersNew[key]['value']] = {
                        [allFiltersNew[key]?.['selectValue']]:
                            allFiltersNew[key]?.['textValue'],
                    };
                }
            });
            postData['filter'] = data;
        }
        props.di
            .POST('amazon/request/exportCSV', postData)
            .then((response: any) => {
                setexportModal(false);
                if (response.success) {
                    props.success(t(response.message));
                    setLoading(false);
                } else {
                    props.error(t(response.message));
                    setLoading(false);
                }
            });
    };
    const { confirm } = ModalAnt;

    const exportProducts = () => {
        let text = (
            <Text as="span">
                A file named{' '}
                <Text as="span" fontWeight="semibold">
                    ${Fileame}
                </Text>
                {t("already exported, Do you want to replace that file ?")}
            </Text>
        );
        if (fileExists) {
            confirm({
                title: t('File already Exists'),
                content: text,
                onOk() {
                    exportProductRequest('replace');
                },
                onCancel() { },
            });
        } else {
            exportProductRequest('new');
        }
    };

    const [files, setFiles] = useState<any>([]);
    const [validImageTypes, setValidImageTypes] = useState<any>(['text/csv']);
    // const validImageTypes = ['text/csv'];
    const [toastProps, setToastProps] = useState({});
    const [selectedRadio, setselectedRadio] = useState(betaSeller.includes(props?.di?.user_id) ? "" : "Bulk-update");

    useEffect(() => {
        if (files.length > 0) {
            setDisable(false);
        }
    }, [files]);

    const fileUpload = !files.length && (
        <DropZone.FileUpload actionHint={`Valid format: ${(selectedRadio == 'FBA-FBM' || selectedRadio == 'FBM-FBA') ? ".xlx/xlsx" : ".csv"} file`} />
    );
    const uploadedFiles = files.length > 0 && (
        <BlockStack gap="200">
            <Text as="span" fontWeight="semibold">
                Added File :
            </Text>
            <Divider borderWidth="050" />
            <div className="custom-replace-section">
                <InlineStack
                    align="space-between"
                    blockAlign="center"
                    gap="400">
                    <InlineStack blockAlign="center" gap="400">
                        <Thumbnail
                            size="small"
                            alt={files.name}
                            source={NoteMinor}
                        />
                        <BlockStack inlineAlign="center">
                            <Text as="span" fontWeight="semibold">
                                {files[0].name}
                            </Text>
                        </BlockStack>
                    </InlineStack>
                    <Button
                        onClick={() => {
                            setFiles([]);
                        }}>
                        {t("Replace")}
                    </Button>
                </InlineStack>
            </div>
            <Divider borderWidth="050" />
        </BlockStack>

    );


    const handleDropZoneDrop = (dropFiles: any) => {
        if (validImageTypes.includes(dropFiles[0].type)) {
            let tempFile = [];
            tempFile = dropFiles;
            setFiles(tempFile);
        } else {
            renderToast(t(`Please Select ${selectedRadio == 'Bulk-update' ? "CSV" : "xlx/xlsx"} file to Upload`), 'error', 2000);
        }
    };
    function prepareheaders() {
        return {
            Authorization:
                'Bearer ' + props.di.globalState.getBearerToken(),
            appCode: btoa(JSON.stringify(environment.appCode)),
            appTag: environment.appTag,
            'Ced-Source-Id': props?.redux?.current?.source?._id,
            'Ced-Source-Name': props?.redux?.current?.source?.marketplace,
            'Ced-Target-Id': props?.redux?.current?.target?._id,
            'Ced-Target-Name': props?.redux?.current?.target?.marketplace,
        };
    }

    const handleImport = () => {
        setLoading(true);
        if (files.length > 0) {
            const formData = new FormData();
            const url = `${environment.API_ENDPOINT}${(selectedRadio == 'FBA-FBM' || selectedRadio == 'FBM-FBA') ? GridApis.changeFulfilment : GridApis.importCSV}`;
            formData.append('file', files[0]);
            (selectedRadio == 'FBA-FBM' || selectedRadio == 'FBM-FBA') && formData.append('fulfillment_type', selectedRadio == 'FBA-FBM' ? 'FBM' : 'FBA');

            fetch(url, {
                headers: { ...prepareheaders() },
                method: 'POST',
                body: formData,
            })
                .then((response: any) => response.json())
                .then((data) => {
                    setLoading(false);
                    setexportModal(false)
                    // setFileame("")
                    setFiles([])
                    betaSeller.includes(props?.di?.user_id) ? setselectedRadio("") : setselectedRadio("Bulk-update")

                    if (data.success) {
                        setimportModal(!importModal);
                        props.success(t(data.message));
                    } else {
                        setimportModal(!importModal);
                        props.error(t(data.message));
                    }
                })
                .catch((error) => {
                    setLoading(false);
                    console.error('Error:', error); // Log the error details for debugging
                    props.error(t('Something Went Wrong'));
                });
        }
    };

    const renderToast = (message: string, type: string, duration: any) => {
        setToastProps({
            message: message,
            error: type !== 'success',
            duration: duration,
        });
        setTimeout(function () {
            setToastProps({});
        }, duration);
    };

    const [selectedTabs, setSelectedTabs] = useState(0);

    const handleRadioChange = useCallback(
        (selection: string) => {
            setFiles([])
            setValidImageTypes(selection == 'Bulk-update' ? "text/csv" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
            setselectedRadio(selection)
        },
        []
    );

    const handleDownload = () => {
        const filePath = 'sample.xlsx'; // Change this to your file name if needed
        const url = `${process.env.REACT_APP_END_POINT}${filePath}`;
        // Create a link element
        const link = document.createElement('a');
        link.href = url;
        link.download = "sample.xlsx";// Set the filename for download

        // Append to the body and trigger the download
        document.body.appendChild(link);
        link.click();

        // Clean up by removing the link
        document.body.removeChild(link);
    };



    const handleTabChange = useCallback(
        (selectedTabIndex: number) => setSelectedTabs(selectedTabIndex),
        []
    );

    const renderImportData = () => {
        if (selectedRadio == 'Bulk-update') {
            return (<>
                <Text as='p'>To ensure seamless Product update, first export the Product information tn the form of CSV file, make necessary changes to this csv file and then import this very same updated CSV file here. All changes will be reflected on App as well as on your Shopify store too.</Text>
                {Fileame.length > 0 && (
                    <Banner>
                        <Text as="span">
                            {t("Last exported file was ")}
                            <Text as="span" fontWeight="semibold">
                                {Fileame}
                            </Text>
                        </Text>
                    </Banner>
                )}
                {files.length == 0 && (
                    <DropZone
                        i18nIsDynamicList
                        allowMultiple={false}
                        onDrop={handleDropZoneDrop}>
                        {fileUpload}
                    </DropZone>
                )}
                {uploadedFiles}
                <InlineStack gap="100">
                    <Link
                        target="_blank"
                        url="https://docs.cedcommerce.com/shopify/amazon-channel-cedcommerce/?section=csv-bulk-action">
                        {t("Need help importing Products?")}
                    </Link>
                </InlineStack>
            </>

            )
        }
        else if (selectedRadio == 'FBA-FBM') {
            return (<>
                <Banner hideIcon tone='warning' icon={AlertMinor} ><Text as='p' >After the import is complete, you need to initiate the <strong>"Sync Product"</strong> action to reflect the changes on Amazon.</Text></Banner>
                <Text as='p'>Effortlessly switch your product fulfillment from FBA to FBM in bulk using an Excel sheet. Simply import the file exported from Amazon into the app, and your changes will be applied automatically. Once done, just initiate the "Sync Product" action for the uploaded products to complete the process.</Text>
                {files.length == 0 && (
                    <DropZone
                        i18nIsDynamicList
                        allowMultiple={false}
                        onDrop={handleDropZoneDrop}>
                        {fileUpload}
                    </DropZone>
                )}
                {uploadedFiles}
                <InlineStack align='space-between' gap="100">
                    <Link
                        target="_blank"
                        url="https://docs.cedcommerce.com/shopify/amazon-channel-cedcommerce/?section=csv-bulk-action">
                        {t("Learn more")}
                    </Link>

                    <Button variant='plain' onClick={() => handleDownload()} icon={ImportMinor}>Download Sample File</Button>
                </InlineStack>
            </>
            )

        }
        else if (selectedRadio == 'FBM-FBA') {
            return (<>
                <Banner hideIcon tone='warning' icon={AlertMinor} ><Text as='p' >After the import is complete, you need to initiate the <strong>"Sync Product"</strong> action to reflect the changes on Amazon.</Text></Banner>
                <Text as='p'>Effortlessly switch your product fulfillment from FBM to FBA in bulk using an Excel sheet. Simply import the file exported from Amazon into the app, and your changes will be applied automatically. Once done, just initiate the "Sync Product" action for the uploaded products to complete the process.</Text>
                {files.length == 0 && (
                    <DropZone
                        i18nIsDynamicList
                        allowMultiple={false}
                        onDrop={handleDropZoneDrop}>
                        {fileUpload}
                    </DropZone>
                )}
                {uploadedFiles}
                <InlineStack align='space-between' gap="100">
                    <Link
                        target="_blank"
                        url="https://docs.cedcommerce.com/shopify/amazon-channel-cedcommerce/?section=csv-bulk-action">
                        {t("Learn more")}
                    </Link>
                    <Button variant='plain' onClick={() => handleDownload()} icon={ImportMinor}>Download Sample File</Button>
                </InlineStack>
            </>
            )

        }

    }




    const tabs: any = [
        {
            id: 'export',
            content: t('Export Products'),
            subcontent: (
                <BlockStack gap="500">
                    <BlockStack gap="100">
                        <Text as="span" fontWeight="semibold">
                            {t("Export Product Information")}
                        </Text>
                        <Text as="span" tone="subdued">
                            {t("Get details of selected/all Products in the form of a CSV document and make the necessary changes to that information.")}
                        </Text>
                    </BlockStack>
                    <ChoiceList
                        title=""
                        choices={options}
                        selected={selected}
                        onChange={handleChange}
                    />
                    <BlockStack gap="100">
                        <Text as="span" fontWeight="semibold">
                            {t("Please select the columns to be exported based on the applied filters")}
                        </Text>
                        <InlineStack gap="300">
                            <Checkbox
                                checked={
                                    !allChecked && indeterminate
                                        ? 'indeterminate'
                                        : allChecked
                                }
                                onChange={handlecheckAll}
                                label={t('All')}></Checkbox>
                            <Checkbox
                                checked={checkedTitle}
                                onChange={handlecheckTitle}
                                label={t('Title')}></Checkbox>
                            <Checkbox
                                checked={checkedInventory}
                                onChange={handlecheckInventory}
                                label={t('Inventory')}></Checkbox>
                            <Checkbox
                                checked={checkedPrice}
                                onChange={handlecheckPrice}
                                label={t('Price')}></Checkbox>
                            <Checkbox
                                checked={checkedBarcode}
                                onChange={handlecheckBarcode}
                                label={t('Barcode')}></Checkbox>
                            <Checkbox
                                checked={checkedSku}
                                onChange={handlecheckSku}
                                label={t('SKU')}></Checkbox>
                        </InlineStack>
                    </BlockStack>
                    <Banner tone="warning">
                        <Text as="span">
                            {t("To ensure seamless Product update, export the Product information in the form of a CSV file, make the necessary updates to this CSV file and then import this very same updated CSV file.")}
                        </Text>
                    </Banner>
                    <InlineStack gap="100">
                        <>
                            {t("Learn more about")}
                            <Link
                                target="_blank"
                                url="https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=how-to-initiate-bulk-updates-of-shopify-products">
                                {t("exporting Products to CSV file")}
                            </Link>{' '}
                            or the{' '}
                            <Link
                                target="_blank"
                                url="https://docs.cedcommerce.com/shopify/multi-account-amazon-cedcommerce/?section=how-to-initiate-bulk-updates-of-shopify-products">
                                {t("bulk editor.")}
                            </Link>
                        </>
                    </InlineStack>
                </BlockStack>
            ),
        },
        betaSeller.includes(props?.di?.user_id) ? {
            id: 'import',
            content: t('Import Products'),
            subcontent: (
                <BlockStack gap="500">
                    <BlockStack gap="100">
                        <Text as="span" fontWeight="semibold">
                            {t("Import Product")}
                        </Text>

                        <Text as="span" tone="subdued">
                            {t("select one of the following actions")}
                        </Text>
                        <InlineStack gap={'200'}>
                            <RadioButton
                                label="Bulk update"
                                // helpText="Customers will only be able to check out as guests."
                                checked={selectedRadio === 'Bulk-update'}
                                id="Bulk-update"
                                name="accounts"
                                onChange={(value) => handleRadioChange("Bulk-update")}
                            />
                            <RadioButton
                                label="FBA to FBM conversion"
                                // helpText="Customers will be able to check out with a customer account or as a guest."
                                id="FBA-FBM"
                                name="accounts"
                                checked={selectedRadio === 'FBA-FBM'}
                                onChange={() => handleRadioChange("FBA-FBM")}
                            />
                            <RadioButton
                                label="FBM to FBA conversion"
                                // helpText="Customers will be able to check out with a customer account or as a guest."
                                id="FBM-FBA"
                                name="accounts"
                                checked={selectedRadio === 'FBM-FBA'}
                                onChange={() => handleRadioChange("FBM-FBA")}
                            />
                        </InlineStack>
                    </BlockStack>
                    {renderImportData()}

                </BlockStack>
            ),
        } : {
            id: 'import',
            content: t('Import Products'),
            subcontent: (
                <BlockStack gap="500">
                    <BlockStack gap="100">
                        <Text as="span" fontWeight="semibold">
                            {t("Import Updated Product CSV")}
                        </Text>
                        <Text as="span" tone="subdued">
                            {t("To ensure seamless Product update, first export the Product information in the form of a CSV file, make the necessary updates to this CSV file and then import this very same updated CSV file. All changes will be reflected on the App as well as on your Shopify store too.")}
                        </Text>
                    </BlockStack>
                    {Fileame.length > 0 && (
                        <Banner>

                            <Text as="span">

                                {t("Last exported file was ")}
                                <Text as="span" fontWeight="semibold">
                                    {Fileame}
                                </Text>
                            </Text>
                        </Banner>
                    )}
                    {files.length == 0 && (
                        <DropZone
                            i18nIsDynamicList
                            allowMultiple={false}
                            onDrop={handleDropZoneDrop}>
                            {fileUpload}
                        </DropZone>
                    )}
                    {uploadedFiles}
                    {/* <InlineStack gap="100">
                        <Link
                            target="_blank"
                            url="https://docs.cedcommerce.com/shopify/amazon-channel-cedcommerce/?section=csv-bulk-action">
                            {t("Need help importing Products?")}
                        </Link>
                    </InlineStack> */}
                </BlockStack>
            ),
        },
    ];

    return (
        <Modal
            open={exportModal}
            onClose={handleChangeExport}
            title={t("Bulk Update")}
            primaryAction={{
                content: selectedTabs == 0 ? t('Export Products') : selectedRadio == 'Bulk-update' ? t("Import Products") : t("Import File"),
                onAction: selectedTabs == 0 ? exportProducts : handleImport,
                loading: loading,
                disabled: disable,
            }}
            secondaryActions={[
                {
                    content: t('Cancel'),
                    onAction: handleChangeExport,
                },
            ]}>
            <Modal.Section>
                <BlockStack gap="400">
                    <BlockStack gap="300">
                        <Text
                            as="p"
                            fontWeight="regular"
                            tone="subdued">
                            {t("This process helps you bulk import or update Shopify products in the app.")}
                        </Text>
                        <Text
                            as="p"
                            fontWeight="regular"
                            tone="subdued">
                            {t("First export details of selected or all products as a CSV document. Make necessary changes to this exported information, and then use the updated CSV to import changes back into the app.")}
                        </Text>
                    </BlockStack>
                    <BlockStack gap="500">
                        <BlockStack gap="200">
                            <Tabs
                                tabs={tabs}
                                selected={selectedTabs}
                                onSelect={handleTabChange}
                            />
                            <Divider />
                        </BlockStack>
                        {tabs[selectedTabs].subcontent}
                    </BlockStack>
                </BlockStack>
            </Modal.Section>
            {Object.keys(toastProps).length > 0 && (
                <AddToast {...toastProps} />
            )}
        </Modal>
    );
};


const RenderBulkModal = (Prop: any) => {
    const { t } = Prop
    const { setActive, actionType, active, amazonLookupBulk, amazonSync } = Prop;
    const [renderElementDetails, setRenderElementDetails] = useState<any>({});
    const [checked, setChecked] = useState<boolean>(false);
    const [activeModal, setActiveModal] = useState<boolean>(false);



    useEffect(() => {
        switch (actionType) {
            case 'Amazon Lookup':
                setRenderElementDetails({
                    title: t('Amazon Lookup'),
                    key: 'Amazon Lookup',
                    description:
                        t('You can choose to run Amazon Lookup for any number of products you want. This will update the status of those products that are currently under “Not Listed: Offer” status.'),
                    actionName:
                        t('Proceed'),
                })
                break;
            case "Sync Status":
                setRenderElementDetails(
                    {
                        title: t('Sync Status'),
                        key: 'Sync Status',
                        description: < BlockStack gap="400" >
                            <Text variant="bodyMd" as="p">{t("This feature allows you to fetch products from Amazon and sync their status with your Shopify products.")}</Text>
                            <Checkbox label={t('Import products from Amazon before syncing.')} onChange={() => setChecked(!checked)} checked={checked} ></Checkbox>
                            <Banner  >
                                <Text as='strong' >{t("Note:")} </Text>{t("Products auto-sync every 24 hours. Use manual import only if you’ve recently added or updated products on Amazon.")}
                            </Banner>
                        </BlockStack >,
                        actionName: t('Proceed'),
                    }
                )
                break;
        }
        setActiveModal(active)
    }, [actionType, checked, active])



    const syncLookupAction = (Data: any, checked: any = false) => {
        setActive(false);
        switch (Data?.key) {
            case 'Sync Status':
                amazonSync(checked);
                break;
            case 'Amazon Lookup':
                amazonLookupBulk();
                break;
        }
    };
    return (
        <Modal
            instant
            open={activeModal}
            onClose={() => { setActive(false); setChecked(false) }}
            title={renderElementDetails.title}
            primaryAction={{
                content: renderElementDetails.actionName,
                onAction: () => { syncLookupAction(renderElementDetails, checked) },
            }}>
            <Modal.Section>
                {renderElementDetails.description}
            </Modal.Section>
        </Modal>
    );
};